import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-agreement',
  imports: [RouterLink],
  templateUrl: './agreement.component.html',
  styleUrl: './agreement.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AgreementComponent {
  effectiveDate: string = 'March 6, 2025';

  constructor() {}

  ngOnInit(): void {}

  printAgreement(): void {
    window.print();
  }

  scrollToContact(event: Event): void {
    event.preventDefault();
    const contactElement = document.getElementById('contact');
    if (contactElement) {
      contactElement.scrollIntoView({ behavior: 'smooth' });
    }
  }
}
